import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ErrorHandlingService } from '../error-handling.service';

export interface IErrorWithText {
  text: string;
}

@Injectable()
export class GlobalHttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorHandlingService: ErrorHandlingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry(1), TODO: check if we want this
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          const resp = error as HttpErrorResponse;
          if (resp.status !== 401 && resp.status < 500 && resp.status !== 0) {
            return throwError(error);
          }
        }

        return this.errorHandlingService.handleError(error);
      })
    );
  }
}
